import React, { useState, useEffect, useCallback } from "react";
import apiClient from "../../axios";
import SuccessNotification from '../Notifications/SuccessNotification';
import LoginNotification from "../Notifications/LoginNotification";
import ErrorNotification from '../Notifications/ErrorNotification';
import Loader from "../Loader";
import Table from '../Table';
import { faFileInvoice } from '@fortawesome/free-solid-svg-icons';

const DataFenix = ({ isVisible, onClose, element }) => {
    const [isInfoVisible, setIsInfoVisible] = useState(false);
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchAllData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await apiClient.get(`/servers/fenix/${element.serverId}`);
            setData(response.data.result.data);
        } catch (error) {
            setIsErrorVisible(true);
            if (error.response && error.response.status === 401) {
                setIsInfoVisible(true);
            }
        } finally {
            setIsSuccessVisible(true);
            setLoading(false);
        }
    }, [element.serverId]);

    useEffect(() => {
        fetchAllData();
    }, [fetchAllData]);

    const handleRefresh = () => {
        fetchAllData();
    };


    const columns = [
        { title: "Empresa", key: "company" },
        { title: "Nro. Facturas", key: "salesCount" },
        { title: "Fecha Última Factura", key: "lastSale" },
        { title: "Fecha Úlitmo Asiento Contable", key: "lastAccounting" },

    ];

    const renderRow = (item, index) => (
        <>
            <td>{item.empresa}</td>
            <td>{item.salescount}</td>
            <td>{item.lastsale}</td>
            <td>{item.lastaccounting}</td>
        </>
    );

    return (
        isVisible && (
            <div className="info-notification-info-overlay">
                <div className="info-notification-info2">
                    <div className="message-container-info">
                        <h3 className="basic-info-form-title">Data en Fenix del Servidor ({element.serverId})</h3>
                    </div>
                    <div className="message-container-info">
                        <Table
                            title="Data"
                            rows={data}
                            columns={columns}
                            icon={faFileInvoice}
                            renderRow={renderRow}
                            currentPage={1}
                            totalItems={1}
                            itemsPerPage={1}
                            onPageChange={1}
                            onRefresh={handleRefresh}
                            loading={loading}
                            flagPagination={true}
                        />
                    </div>
                    <div className="button-container-info">
                        <button className="ok-btn-info" onClick={onClose}>
                            Ok
                        </button>
                    </div>
                    {loading && <Loader />}
                    <SuccessNotification
                        message={"Se ha cargado correctamente"}
                        isVisible={isSuccessVisible}
                        onClose={() => setIsSuccessVisible(false)}
                    />
                    <ErrorNotification
                        message="Ups! Ocurrió un Problema"
                        isVisible={isErrorVisible}
                        onClose={() => setIsErrorVisible(false)}
                    />
                    <LoginNotification
                        message="Vuelve a iniciar sesión"
                        isVisible={isInfoVisible}
                        onClose={() => setIsInfoVisible(false)}
                    />
                </div>
            </div >
        )
    );
};

export default DataFenix;
